import { useCallback, useState } from "react";
import { Button, Typography } from "@mui/material";
import { makeStyles } from "components/providers/makeStyles";
import { Link } from "react-router-dom";

import { HeatSnippet } from "../heat/HeatSnippet";
import { T } from "../../util/t";
import { LoadingHeatModal } from "../heat/HeatModal";
import { LoadingLeaderboardModal } from "../leaderboard/LeaderboardModal";
import { WatchLiveButton } from "components/routes/events/id/watch/WatchLiveButton";

export const EventScheduleSnippet = ({ event }) => {
    const {
        fullSchedule: { podiums },
        status,
        hideScheduledTime,
        config,
    } = event;
    const shouldDisplay =
        podiums &&
        ["published", "on_hold", "on"].indexOf(status) !== -1 &&
        !(hideScheduledTime && config?.disableSchedule);
    const [clickedHeat, setClickedHeat] = useState(null);
    const closeModal = useCallback(() => setClickedHeat(null), []);
    const ModalComponent = clickedHeat?.config.runBased
        ? LoadingLeaderboardModal
        : LoadingHeatModal;

    return (
        <>
            <ModalComponent
                heat={clickedHeat}
                open={!!clickedHeat}
                closeModal={closeModal}
            />
            {shouldDisplay && (
                <EventScheduleSnippetContent
                    event={event}
                    onHeatClicked={setClickedHeat}
                />
            )}
        </>
    );
};

const useStyles = makeStyles((theme) => ({
    section: {
        marginBottom: theme.spacing(4),
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    link: {
        width: "100%",
    },
}));
export const EventScheduleSnippetContent = ({ event, onHeatClicked }) => {
    const classes = useStyles();
    const displayPodium = event.fullSchedule.podiums.reduce(
        (display, podium) => display && !!podium.heats.filter((h) => h).length,
        true,
    );
    const heats = [event.currentScheduleIndex, event.currentScheduleIndex + 1]
        .reduce((heats, index) => {
            heats.push(
                ...event.fullSchedule.podiums.map(
                    (podium) => podium.heats[index],
                ),
            );
            return heats;
        }, [])
        .filter((h) => h);

    return (
        <section className={classes.section}>
            {!event.config?.disableSchedule && (
                <>
                    <Typography
                        variant="h5"
                        component="h2"
                        className={classes.title}
                    >
                        {event.status === "on" ? (
                            <T>What's on</T>
                        ) : (
                            <T>Up next</T>
                        )}
                    </Typography>
                    <WatchLiveButton eventId={event.id} />
                    {heats.map((heat) => (
                        <div key={heat.id} onClick={() => onHeatClicked(heat)}>
                            <HeatSnippet
                                heat={heat}
                                displayPodium={displayPodium}
                            />
                        </div>
                    ))}
                </>
            )}

            {!event.hideScheduledTime && (
                <Button
                    className={classes.link}
                    variant="outlined"
                    component={Link}
                    to={`/events/${event.id}/schedule`}
                >
                    <T>View schedule</T>
                </Button>
            )}
        </section>
    );
};
